import { render, staticRenderFns } from "./MultiChoiceCardsList.vue?vue&type=template&id=a790db9c&"
import script from "./MultiChoiceCardsList.vue?vue&type=script&lang=ts&"
export * from "./MultiChoiceCardsList.vue?vue&type=script&lang=ts&"
import style0 from "./MultiChoiceCardsList.vue?vue&type=style&index=0&id=a790db9c&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports